import React from "react";
import { SbTag, SbTooltip } from "uiCore";
import { getScoreColor } from "Utils/scoreColor.utils";
import IndexTooltip from "./IndexTooltip";

// The SMI tag every "next best-matched roles" row shows next to a role
// (AtRiskDetailPanel, PlanNextRolesPanel) — factored out once both needed the
// same null-score fallback: sri is null (not 0) when the person hasn't
// updated their profile against that role yet (see useTalentMobilityData's
// mapNextRoleToRow), and rendering that as "0% SMI" would read as an actual
// rock-bottom match rather than "no data yet". Dash + tooltip instead, same
// convention RoleDetailV2's own SMI column falls back to for its equivalent
// (differently-sourced) case.
const NextRoleMatchTag = ({ sri, thresholds }) =>
  sri == null ? (
    <SbTooltip content="User has not updated profile">—</SbTooltip>
  ) : (
    <IndexTooltip index="SMI">
      <SbTag color={getScoreColor(sri, thresholds)}>{sri}% SMI</SbTag>
    </IndexTooltip>
  );

export default NextRoleMatchTag;
